export default __webpack_public_path__ + "static/media/onto-logo.b000b270.svg";